import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type QuoteFreightMode = "all" | "Sea" | "Air" | "Road" | "Warehouse";
export type QuoteStatus = "all" | "Quoting" | "Sent";

interface QuotesState {
	filterFreightMode: QuoteFreightMode;
	filterStatus: QuoteStatus;
}

const initialState: QuotesState = {
	filterFreightMode: "all",
	filterStatus: "all",
};

const quotesSlice = createSlice({
	name: "quotes",
	initialState,
	reducers: {
		setFilterFreightMode: (state, action: PayloadAction<QuoteFreightMode>) => {
			state.filterFreightMode = action.payload;
		},
		setFilterStatus: (state, action: PayloadAction<QuoteStatus>) => {
			state.filterStatus = action.payload;
		},
	},
});

export const { setFilterFreightMode, setFilterStatus } = quotesSlice.actions;
export default quotesSlice.reducer;
